<div class="error-page">
  <empty-state
    [img]="'./assets/images/404Error-rafiki.svg'"
    [title]="'general.Page not found' | translate"></empty-state>
</div>
